export const EXTERNAL_LINK_CONFIRMATION_TEXT =
  "LINEミニアプリの外部に遷移します。\n一部の機能が動作しない場合があります。よろしいですか？";
